<template>
  <div class="parentDetail">

    <div class="title">
      <VTitle page-title="已上课程"></VTitle>
    </div>

    <div class="contentdetail">
      <div class="content">

        <div class="nameIcon"></div>
        <div class="nameContent" v-text='obj.title'></div>

        <div class="goalIcon"></div>
        <div class="goalContent" v-text='obj.teachingObjectives'></div>

        <div class="passIcon"></div>
        <div class="passContent" v-text='obj.teachingProcess'></div>

        <!-- <div class="attitudeIcon"></div>
        <div class="attitudeContent" v-text='obj.expression'></div> -->

        <div class="photoIcon"></div>
        <div class="photoContent">
          <img v-for="object,index in obj.imageUrl"
               :src="object"
               :key="index"
               class="photodetail"
               v-tap="{methods:handleClick,index:index}"
               alt="">
        </div>

      </div>
    </div>

    <div>
      <VGoBackBtn></VGoBackBtn>
    </div>

  </div>
</template>

<script type="text/ecmascript-6">
  import VTitle from '../../components/VTitle.vue';
  import VGoBackBtn from '../../components/VGoBackBtn.vue';
  import netTool from '../../api/netTool';
  import { Toast } from 'mint-ui';
  export default{
    data() {
      return {
        obj: {
          title: '',
          teachingObjectives:'',
          teachingProcess:'',
          imageUrl:[]
        }
      };
    },
    created() {
      this.getData();
    },
    deactivated() {
      this.$destroy();
    },
    components: {VTitle, VGoBackBtn},
//    props: {
//      obj: {
//        type: Object
//      }
//    },
    methods: {
      getData () {
        netTool.detailCourse(this.$route.query.id).then(response => {
          if (response.code == '0') {
            this.obj = response.data;
          } else {
            Toast({message: response.msg, position: 'middle', duration: 3000});
          }
        })
        .catch(error => {
          console.log(error);
        });
      },
      handleClick(params) {
        let index = params.index;
        this.$store.commit('setImgInfo', {imgs: this.obj.imageUrl, index: index});
        this.$router.push({path: '/picture-view'});
      }
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../../assets/scss/base.scss';

  .parentDetail {
    @include bg-img('../../assets/img/common/Bg');
    width: px2rem(750);
    font-size: px2rem(40);
    .title {
      float: left;
      margin-top: px2rem(70);
      margin-left: px2rem(166);
    }
  }

  .contentdetail {

    height: px2rem(1035 - 55);
    width: px2rem(690);
    margin-left: px2rem(27);
    padding-top: px2rem(55);
    background-color: rgba(221, 193, 142, 1);
    margin-top: px2rem(130);
    border-radius: px2rem(10);
    .content {
      width: px2rem(618);
      height: px2rem(948);
      margin-left: px2rem(35);
      overflow-y: auto;
      overflow-x: hidden;
      -webkit-overflow-scrolling: touch;
    }
  }

  .nameIcon {
    @include bg-img('../../assets/img/parentRecord/name');
    width: px2rem(175);
    height: px2rem(81);
  }

  .nameContent {
    width: px2rem(578);
    height: px2rem(30);
    line-height: 1.5;
    padding-top: px2rem(15);
    padding-bottom: px2rem(15);
    padding-left: px2rem(32);
    border-radius: px2rem(10);
    background-color: rgba(251, 246, 220, 1);
    margin-bottom: px2rem(10);
    font-size: px2rem(25);
  }

  .goalIcon {
    @include bg-img('../../assets/img/parentRecord/goal');
    width: px2rem(175);
    height: px2rem(81);
  }

  .goalContent {
    width: px2rem(578 - 15);
    line-height: 1.5;
    padding-top: px2rem(15);
    padding-bottom: px2rem(15);
    padding-right: px2rem(15);
    padding-left: px2rem(32);
    border-radius: px2rem(10);
    background-color: rgba(251, 246, 220, 1);
    margin-bottom: px2rem(10);
    font-size: px2rem(25);
  }

  .passIcon {
    @include bg-img('../../assets/img/parentRecord/pass');
    width: px2rem(175);
    height: px2rem(81);
  }

  .passContent {
    width: px2rem(578 - 15);
    line-height: 1.5;
    padding-top: px2rem(15);
    padding-bottom: px2rem(15);
    padding-right: px2rem(15);
    padding-left: px2rem(32);
    border-radius: px2rem(10);
    background-color: rgba(251, 246, 220, 1);
    margin-bottom: px2rem(10);
    font-size: px2rem(25);
  }

  .attitudeIcon {
    @include bg-img('../../assets/img/parentRecord/attitude');
    width: px2rem(175);
    height: px2rem(81);
  }

  .attitudeContent {
    width: px2rem(578 - 15);
    line-height: 1.5;
    padding-top: px2rem(15);
    padding-bottom: px2rem(15);
    padding-right: px2rem(15);
    padding-left: px2rem(32);
    border-radius: px2rem(10);
    background-color: rgba(251, 246, 220, 1);
    margin-bottom: px2rem(10);
    font-size: px2rem(25);
  }

  .photoIcon {
    @include bg-img('../../assets/img/parentRecord/photo');
    width: px2rem(175);
    height: px2rem(81);
  }

  .photoContent {
    width: px2rem(578 - 15);
    line-height: px2rem(30);
    padding-top: px2rem(15);
    padding-bottom: px2rem(15);
    padding-right: px2rem(15);
    padding-left: px2rem(32);
    border-radius: px2rem(10);
    background-color: rgba(251, 246, 220, 1);
    margin-bottom: px2rem(10);
    font-size: px2rem(25);
  }

  .photodetail {
    width: px2rem(78);
    height: px2rem(78);
    margin-top: px2rem(10);
    margin-left: px2rem(10);
  }

  .parentDetail:after {
    display: block;
    clear: both;
    content: '';
  }
</style>



// WEBPACK FOOTER //
// courseDetail.vue?3cf20b90